import styled from 'styled-components';
import Color from 'constants/color';

export const BackgroundLoginPage = styled.div`
  width: 100%;
  height: 100%;
  background-image: url('/assets/background/realworld.png');
  overflow: hidden;
  object-fit: cover;
  background-repeat: no-repeat;
  background-size: cover;
  position: absolute;
  z-index: 0;
`;

export const OverlayBackground = styled.div`
  opacity: 0.53;
  background: ${Color.black};
  min-height: 100%;
  min-width: 100%;
  position: absolute;
  z-index: 0;
`;
